(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-categories-slider"] && !Shopify.designMode) return;
  try {
    
  function initHxCatNav(root){
    const track = root.querySelector('.hx-cat-slider__track');
    const nav   = root.querySelector('.hx-cat-slider__nav');
    if (!track || !nav) return;
    const prev = nav.querySelector('.hx-cat-slider__btn--prev');
    const next = nav.querySelector('.hx-cat-slider__btn--next');

    const updateArrows = () => {
      const atStart = track.scrollLeft <= 1;
      const atEnd   = Math.ceil(track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 1);
      prev?.toggleAttribute('disabled', atStart);
      next?.toggleAttribute('disabled', atEnd);
    };

    const updateNavVisibility = () => {
      const hasOverflow = (track.scrollWidth - track.clientWidth) > 2;
      nav.classList.toggle('is-hidden', !hasOverflow);
      updateArrows();
    };

    window.addEventListener('resize', updateNavVisibility, { passive:true });
    track.addEventListener('scroll', updateArrows, { passive:true });
    track.querySelectorAll('img').forEach(img => {
      if (!img.complete) img.addEventListener('load', updateNavVisibility, { once:true });
    });
    updateNavVisibility();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.hx-cat-slider').forEach(initHxCatNav);
  });

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.hx-cat-slider__btn');
    if (!btn) return;
    const dir = parseInt(btn.dataset.dir || '1', 10);
    const track = document.querySelector(btn.dataset.target);
    if (!track) return;
    const delta = track.clientWidth * 0.9 * dir;
    track.scrollBy({ left: delta, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
